import { createDefaultQueryClient } from "@marekl/adminer/api";

export const queryClient = createDefaultQueryClient();
